import {
    DateInput,
    AutocompleteInput,
    NumberInput,
    TextInput,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { Grid } from '@mui/material';
import { format } from '@helpers/numeric.ext';
import { orderStatus } from '@src/entityResource';

export const OrderForm = () => {
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <DateInput source="createdAt" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <AutocompleteInput
                        source="transactionStatus"
                        choices={orderStatus}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextInput source="transactionType" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextInput source="invoiceNo" />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="transactionAmount" />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="transactionCost" format={format} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="transactionMargin" format={format} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="zakat" format={format} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="incentiveMargin" format={format} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="incentiveAmount" format={format} />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
